import React, { lazy, Suspense, useRef, useEffect, useState } from "react";
import { Container, Row, Col, Button, Spinner } from "react-bootstrap";
import AngelButton from "./AngelButton";
import "./index.css";

const Pavan = lazy(() => import('../Pavan'))

export default function Banner() {
    const imgCDNURL = process.env.REACT_APP_CDN + "swmc-niches/";
    const animationRef = useRef(null);

    // Individual gradient configurations with separate refs
    const gradients = [
        {
            id: 1,
            ref: useRef(null),
            className: 'gradient-1',
            speedX: 0.3,
            speedY: 0.4,
            rangeX: 80,
            rangeY: 70,
            offsetX: 10,
            offsetY: 15
        },
        {
            id: 2,
            ref: useRef(null),
            className: 'gradient-2',
            speedX: -0.25,
            speedY: 0.35,
            rangeX: 75,
            rangeY: 60,
            offsetX: 15,
            offsetY: 20
        },
        {
            id: 3,
            ref: useRef(null),
            className: 'gradient-3',
            speedX: 0.4,
            speedY: -0.3,
            rangeX: 85,
            rangeY: 80,
            offsetX: 5,
            offsetY: 10
        },
        {
            id: 4,
            ref: useRef(null),
            className: 'gradient-4',
            speedX: -0.35,
            speedY: 0.45,
            rangeX: 70,
            rangeY: 75,
            offsetX: 20,
            offsetY: 5
        },
        {
            id: 5,
            ref: useRef(null),
            className: 'gradient-5',
            speedX: 0.2,
            speedY: -0.38,
            rangeX: 90,
            rangeY: 65,
            offsetX: 0,
            offsetY: 25
        }
    ];

    // Animation loop
    useEffect(() => {
        let startTime = Date.now();

        const animate = () => {
            const currentTime = Date.now();
            const elapsed = (currentTime - startTime) * 0.001;

            gradients.forEach((gradient) => {
                if (gradient.ref.current) {
                    const moveX = gradient.offsetX + (Math.sin(elapsed * gradient.speedX) + 1) * gradient.rangeX / 2;
                    const moveY = gradient.offsetY + (Math.cos(elapsed * gradient.speedY) + 1) * gradient.rangeY / 2;

                    const rotation = Math.sin(elapsed * gradient.speedX * 0.5) * 20;
                    const scale = 0.7 + Math.sin(elapsed * gradient.speedY * 0.4) * 0.4;
                    const opacity = 0.6 + Math.sin(elapsed * gradient.speedX * 0.6) * 0.3;

                    const element = gradient.ref.current;
                    element.style.left = `${moveX}%`;
                    element.style.top = `${moveY}%`;
                    element.style.transform = `translate(-50%, -50%) rotate(${rotation}deg) scale(${scale})`;
                    element.style.opacity = Math.max(0.3, Math.min(0.9, opacity));
                }
            });

            animationRef.current = requestAnimationFrame(animate);
        };

        animate();

        return () => {
            if (animationRef.current) {
                cancelAnimationFrame(animationRef.current);
            }
        };
    }, []);

    return (
        <section id="banner">
            <div className="risk-gradient-container">
                {gradients.map((gradient) => (
                    <div
                        key={gradient.id}
                        ref={gradient.ref}
                        className={`risk-gradient-element ${gradient.className}`}
                    />
                ))}
            </div>
            <Container className="banner-container">
                <Row>
                    <Col lg={6} className="banner-left-side">
                        <h1 className="banner-title mb-0">
                            One-Stop Shop <br />for All Niches
                        </h1>
                        <h2 className="by-swmc">
                            by Sun West
                        </h2>
                        <div className="banner-paras-div">
                            <p className="banner-paras">
                                For too long, the mortgage industry has favored borrowers with ideal profiles—leaving many underserved. <a className='custom-hyperlink' href='https://www.swmc.com' target='_blank'rel='noreferrer'>Sun West</a> and <a className='custom-hyperlink' href='https://www.swmc.com/angelai/' target='_blank' rel='noreferrer'>AngelAi</a>™ are changing that with inclusive lending solutions designed for every borrower profile, even those with lower credit scores, or unique circumstances.
                            </p>
                            <p className="banner-paras">
                                Our programs empower mortgage brokers to serve more clients, close more loans, and stand out in competitive markets.
                            </p>
                            <p className="banner-paras">
                                Simply chat with <a className='custom-hyperlink' href='https://www.swmc.com/angelai/' target='_blank' rel='noreferrer'>AngelAi</a> - 24/7 Ai assistant designed for mortgage professionals, and experience the future of lending.
                            </p>
                        </div>
                        {/* <div className="banner-button-container">
                            <AngelButton
                                onClick={() => window.open('https://www.swmc.com/angelai/', '_blank')}
                                text="Ask Angel"
                            />
                        </div> */}
                    </Col>
                    <Col lg={6} className="banner-right-side">
                        <Suspense fallback={<Spinner />}>
                            <Pavan />
                        </Suspense>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}